<template>
  <div>
    <a-modal
      v-model="isShowFirstStepModal"
      centered
      :width="800"
      :mask-closable="false"
      ok-text="下一步"
      :ok-button-props="{ props: { loading: firstStepSubmitting } }"
      title="切换运营商"
      @ok="handleValidate"
    >
      <a-row>
        <a-form
          class="iotplt-compact-form"
          :form="firstStepForm"
          @submit="handleValidate"
        >
          <a-col :span="24">
            <a-form-item
              :wrapper-col="{ span: 24 }"
            >
              <common-card-input
                :rows="15"
                :type="1"
                ref="iccidInput"
                @change="handleIccidsChange"
                v-decorator="['iccids', {
                  initialValue: { data: this.iccids },
                  rules: [{ validator: checkIccids }],
                }]"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>

    <a-modal
      v-model="isShowSubmitModal"
      centered
      :width="600"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting, disabled: !isCanSubmit } }"
      title="切换运营商"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form
          class="iotplt-compact-form"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 15 }"
          :form="submitForm"
          @submit="handleSubmit"
        >
          <a-form-item label="已选择卡数">
            <a-input
              disabled
              v-model="this.validIccids.length"
            />
          </a-form-item>

          <a-form-item
            label="切换至运营商"
          >
            <a-select
              @change="handleCarrierChange"
              show-search
              allow-clear
              :filter-option="filterOption"
              :loading="loadingCarrierOptions"
              v-decorator="['carrier_value', {
                rules: [
                  { required: true, message: '请选择运营商' }
                ]
              }]"
            >
              <a-select-option
                v-for="option in carrierOptions"
                :key="option.carrier_value"
                :value="option.carrier_value"
                :carrier_text="option.carrier_name"
              >
                {{ option.carrier_name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { switchCarrier, switchCarrierSearch, validateSwitchCarrier } from '@/api/batch_operation'
import CommonCardInput from '@/components/CardInput/Common'

export default {
  name: 'BatchOperationSwitchCarrier',
  components: { CommonCardInput },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    iccids: {
      type: Array,
      default() {
        return []
      }
    },
    agentId: {
      type: Number,
      required: true
    }
  },
  data() {
    const isShowFirstStepModal = this.visible
    return {
      loadingCarrierOptions: false,
      carrierOptions: [],
      firstStepSubmitting: false,
      submitting: false,
      cardType: 0,
      validIccids: [],
      selectedCarrierText: '',
      isShowFirstStepModal: isShowFirstStepModal,
      isShowSubmitModal: false,
      isCanSubmit: false, // 是否可以提交切换运营商
      firstStepForm: this.$form.createForm(this, { name: 'set_sim_iccids_to_agency_first_step' }),
      submitForm: this.$form.createForm(this, { name: 'set_sim_iccids_to_agency_submit' })
    }
  },
  watch: {
    // 步骤中任何一个弹窗打开，则 isShow 应为 true
    isShowFirstStepModal(val) {
      this.isShow = val || this.isShowSubmitModal
    },

    isShowSubmitModal(val) {
      this.isShow = val || this.isShowFirstStepModal
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },

    topAgentId() {
      return this.$store.getters.userAgentId
    }
  },
  created() {
  },
  methods: {
    handleCarrierChange(value, e) {
      this.selectedCarrierText = e.data.attrs.carrier_text
    },

    handleIccidsChange(value) {
      this.cardType = value.cardType
    },

    checkIccids(rule, value, callback) {
      if (!value || !value.inputValue) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入卡号')
        return
      }

      if (value.validateStatus === 'error') {
        callback(value.errorMsg)
        return
      }

      // eslint-disable-next-line standard/no-callback-literal
      callback()
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },

    handleValidate(e) {
      e.preventDefault()
      if (this.firstStepSubmitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.firstStepForm.validateFields((err, values) => {
        if (!err) {
          this.firstStepSubmitting = true
          validateSwitchCarrier({
            iccids: values.iccids.data
          }).then((res) => {
            if (res.code === 0) {
              if (res.data.is_valid) {
                this.isCanSubmit = true

                this.validIccids = values.iccids.data

                // 获取可选套餐
                this.loadingCarrierOptions = true

                switchCarrierSearch({
                  iccids: values.iccids.data
                }).then((res) => {
                  if (res.code === 0) {
                    this.carrierOptions = res.data

                    // 关闭模态框
                    this.isShowSubmitModal = true
                    this.isShowFirstStepModal = false
                  }

                  this.loadingCarrierOptions = false
                })
              } else {
                this.firstStepForm.setFieldsValue({
                  iccids: { inputValue: res.data.result }
                })
                this.$nextTick(() => {
                  this.$refs.iccidInput.handleCards()
                })
              }
            }
            this.firstStepSubmitting = false
          })
        }
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.submitForm.validateFields((err, values) => {
        if (!err) {
          this.submitting = true

          switchCarrier({
            ...values,
            carrier_value: values.carrier_value,
            carrier_text: this.selectedCarrierText,
            iccids: this.validIccids
          }).then((res) => {
            if (res.code === 0) {
              this.isShowSubmitModal = false
              // 告知父组件已完成
              this.$emit('completed')
              this.$success({
                title: '提交成功',
                content: (
                  <div>
                    <p>操作成功，具体操作结果请至 【系统查询】-【批量操作查询】 查看</p>
                  </div>
                )
              })
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
